import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import styles from './Forms.scss';

function FormItemSmall({ children }) {
    return (<div className={styles['form-item-small']}>
        {children}
    </div>)
}

FormItemSmall.displayName = displayName('Forms/FormItemSmall');

FormItemSmall.propTypes = {
    children: PropTypes.node.isRequired,
};

export default FormItemSmall;
